import { Box } from '@wix/design-system';
import { PaymentMethodIcons } from '@wix/premium-purchase-platform/@ui';
import React from 'react';
import CreditCardIcon from '../../assets/icons/credit-card.svg';
import RefundIcon from '../../assets/icons/refund.svg';
import SslShield from '../../assets/icons/ssl-shield.svg';
import { eclipseServerData } from '../../utils';
import { useCurrentModule } from '../ModuleProvider';
import { getLocalePaymentMethods } from './getLocalePaymentMethods';
import { TrustBuilderItem } from './TrustBuilderItem';
import s from './TrustBuilders.scss';
export const TRUST_BUILDERS_REDESIGN_DATA_HOOK = 'trust-builders-redesign';
export const TRUST_BUILDER_PAYMENT_METHODS_DATA_HOOK = 'trust-builder-payment-methods';
export const TRUST_BUILDER_MONEY_BACK_DATA_HOOK = 'trust-builder-money-back';
export const TRUST_BUILDER_SSL_DATA_HOOK = 'trust-builder-ssl';
export const TRUST_BUILDER_DIVIDER_DATA_HOOK = 'trust-builder-divider';
const MONEY_BACK_TITLE_KEY = {
  default: 'page_footer.money_back_guarantee',
  existingSubscription: 'page_footer.money_back_guarantee_second_upgrade'
};
const MONEY_BACK_DESCRIPTION_KEY = {
  default: 'page_footer.try_14_days',
  existingSubscription: 'app.second_upgrade_text'
};
export const RedesignedTrustBuilders = _ref => {
  var _offeringQuery$data;
  let {
    paymentMethods
  } = _ref;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    geo
  } = eclipseServerData.get();
  const offeringQuery = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const isInitialPurchase = !((_offeringQuery$data = offeringQuery.data) != null && (_offeringQuery$data = _offeringQuery$data.currentSubscriptionInfo) != null && _offeringQuery$data.productId);
  const moneyBackVariant = isInitialPurchase ? 'default' : 'existingSubscription';
  const redesignPaymentMethods = paymentMethods ?? getLocalePaymentMethods(geo);
  const hasPaymentMethods = Boolean(redesignPaymentMethods.length);
  const items = [hasPaymentMethods && /*#__PURE__*/React.createElement(TrustBuilderItem, {
    key: "payment-methods",
    dataHook: TRUST_BUILDER_PAYMENT_METHODS_DATA_HOOK,
    pinDescriptionToBottom: true,
    icon: /*#__PURE__*/React.createElement(CreditCardIcon, null),
    title: t('page_footer.accepted_payment_methods'),
    description: /*#__PURE__*/React.createElement(PaymentMethodIcons, {
      paymentMethods: redesignPaymentMethods
    })
  }), /*#__PURE__*/React.createElement(TrustBuilderItem, {
    key: "money-back",
    dataHook: TRUST_BUILDER_MONEY_BACK_DATA_HOOK,
    widthWeight: "1.2",
    icon: /*#__PURE__*/React.createElement(RefundIcon, null),
    title: t(MONEY_BACK_TITLE_KEY[moneyBackVariant]),
    description: t(MONEY_BACK_DESCRIPTION_KEY[moneyBackVariant])
  }), /*#__PURE__*/React.createElement(TrustBuilderItem, {
    key: "ssl",
    dataHook: TRUST_BUILDER_SSL_DATA_HOOK,
    icon: /*#__PURE__*/React.createElement(SslShield, null),
    title: t('page_footer.ssl_secure_payment'),
    description: t('page_footer.information_encryption')
  })].filter(item => Boolean(item));
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: TRUST_BUILDERS_REDESIGN_DATA_HOOK,
    className: s.strip,
    direction: "horizontal",
    align: "center",
    verticalAlign: "top",
    width: "100%",
    padding: "0 20px",
    boxSizing: "border-box"
  }, items.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, index > 0 && /*#__PURE__*/React.createElement(Box, {
    dataHook: TRUST_BUILDER_DIVIDER_DATA_HOOK,
    className: s.divider,
    flexShrink: "0"
  }), item)));
};
//# sourceMappingURL=RedesignedTrustBuilders.js.map